import * as React from "react";
import {uniqueId} from "../tools";
import {Autocomplete as AC} from '@mui/material';
import TextField from '@mui/material/TextField';
import {useState} from "react";

import "./Autocomplete.css";

function Autocomplete(props) {
    const [value, setValue] = useState(props.value || '');
    const [inputValue, setInputValue] = useState(props.value || '');

    const disabled = props.disabled || false;
    const id = uniqueId();
    const idKey = `& FormAutcomplete_${id}`;
    const colWidth = props.colWidth || 50;
    let className = `col-${colWidth}`;
    props.className && (className = `${className} ${props.className}`);

    const onChange = (_, selectedVal) => {
        setValue(selectedVal);
        props.onChange?.(props.name, selectedVal);
    }

    return (
        <div className={className}>
            {props.label && <label htmlFor={id}>{props.label}</label>}
            <AC
                disablePortal
                getOptionLabel={(option) => option.label}
                id={idKey}
                options={props.options}
                value={value}
                // inputValue={inputValue}
                onInputChange={(event, newInputValue) => {
                    setInputValue(newInputValue);
                }}
                onChange={onChange}
                sx={{
                    // border: "1px solid blue",
                    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                        border: "none"
                    },
                    "& .MuiFormControl-root .MuiInputBase-root .MuiInputBase-input.MuiOutlinedInput-input": {
                        padding: "0 1.5rem"
                    }
                }} renderInput={(params) => <TextField type="text" id={id}
                                                       {...params} placeholder={props.placeholder || ''}
                                                       disabled={disabled}/>
            }
            />
        </div>
    );
}

export default Autocomplete;